import { render, staticRenderFns } from "./TopScore.vue?vue&type=template&id=468de0ae"
import script from "./TopScore.vue?vue&type=script&lang=js"
export * from "./TopScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports